import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BottomNavigation from '../components/BottomNavigation';
import './LiveSessionsList.css';

const LiveSessionsList: React.FC = () => {
  const navigate = useNavigate();
  const [filter, setFilter] = useState<'all' | 'upcoming' | 'past'>('all');

  // Mock data
  const sessions = [
    {
      id: 1,
      title: 'Live Math Session',
      instructor: 'Dr. Smith',
      date: '2024-02-10',
      time: '15:00',
      status: 'upcoming',
      enrolled: 45,
      platform: 'BBB'
    },
    {
      id: 2,
      title: 'English Conversation',
      instructor: 'Ms. Johnson',
      date: '2024-02-08',
      time: '10:00',
      status: 'past',
      enrolled: 32,
      platform: 'Google Meet'
    },
    {
      id: 3,
      title: 'Science Lab Demo',
      instructor: 'Dr. Williams',
      date: '2024-02-12',
      time: '14:00',
      status: 'upcoming',
      enrolled: 28,
      platform: 'BBB'
    }
  ];

  const filteredSessions = sessions.filter(session => {
    if (filter === 'all') return true;
    return session.status === filter;
  });

  const handleSessionClick = (sessionId: number, status: string) => {
    if (status === 'upcoming') {
      navigate(`/live-session/${sessionId}`);
    } else {
      navigate(`/live-session/${sessionId}/recordings`);
    }
  };

  return (
    <div className="live-sessions-list-page">
      <header className="live-sessions-header">
        <h1>Live Sessions</h1>
        <p className="header-subtitle">Join interactive learning sessions</p>
      </header>

      <div className="live-sessions-content">
        {/* Filter Tabs */}
        <div className="filter-tabs">
          <button
            className={`filter-tab ${filter === 'all' ? 'active' : ''}`}
            onClick={() => setFilter('all')}
          >
            All
          </button>
          <button
            className={`filter-tab ${filter === 'upcoming' ? 'active' : ''}`}
            onClick={() => setFilter('upcoming')}
          >
            Upcoming
          </button>
          <button
            className={`filter-tab ${filter === 'past' ? 'active' : ''}`}
            onClick={() => setFilter('past')}
          >
            Past
          </button>
        </div>

        {/* Sessions List */}
        <div className="sessions-list">
          {filteredSessions.map((session) => (
            <div
              key={session.id}
              className={`session-card ${session.status}`}
              onClick={() => handleSessionClick(session.id, session.status)}
            >
              <div className="session-header">
                <div className="session-icon">
                  {session.status === 'upcoming' ? '🔴' : '📹'}
                </div>
                <div className="session-info">
                  <h3 className="session-title">{session.title}</h3>
                  <p className="session-instructor">{session.instructor}</p>
                </div>
                <span className={`session-status-badge ${session.status}`}>
                  {session.status === 'upcoming' ? 'Upcoming' : 'Past'}
                </span>
              </div>

              <div className="session-details">
                <div className="session-detail-item">
                  <span className="detail-icon">📅</span>
                  <span>{session.date}</span>
                </div>
                <div className="session-detail-item">
                  <span className="detail-icon">🕐</span>
                  <span>{session.time}</span>
                </div>
                <div className="session-detail-item">
                  <span className="detail-icon">👥</span>
                  <span>{session.enrolled} enrolled</span>
                </div>
                <div className="session-detail-item">
                  <span className="detail-icon">💻</span>
                  <span>{session.platform}</span>
                </div>
              </div>

              {session.status === 'upcoming' && (
                <button className="join-button">
                  Join Session
                </button>
              )}
              {session.status === 'past' && (
                <button className="watch-recording-button">
                  Watch Recording
                </button>
              )}
            </div>
          ))}
        </div>
      </div>

      <BottomNavigation />
    </div>
  );
};

export default LiveSessionsList;
